import { useMutation, useQuery } from "react-query";

import { BillingEngineService } from "services";

export const useAddOrganizationNsSettingsInfo = () => {
  return useMutation(BillingEngineService.addOrganizationNsSettingsInfo);
};

export const useOrganizationNsSettingsInfo = (organizationId: string) => {
  return useQuery(
    ["fetchMultiOrganizationInvoiceIndex", organizationId],
    () => BillingEngineService.getOrganizationNsSettingsInfo(organizationId),
    {
      refetchOnWindowFocus: false,
    }
  );
};
